module.exports = __webpack_public_path__ + "static/img/4.d9a636ac.png";